import { useState } from 'react';

import { IntegrationEventRefModel } from '../../Models/DomainServiceModel';
import GenericPropertyInput from './GenericPropertyInput';
import GenericPropertyInputRefContent from './GenericPropertyInputRefContent';
import { IntegrationEventInputDialog } from './IntegrationEventInputDialog';

type IntegrationEventInputProps = {
	integrationEventRef: IntegrationEventRefModel | undefined;
	onIntegrationEventRefChange: (integrationEventRef: IntegrationEventRefModel | undefined) => void;
	isEditable?: boolean;
};

export default function IntegrationEventInput({ integrationEventRef, onIntegrationEventRefChange, isEditable = true }: IntegrationEventInputProps) {
	const [open, setOpen] = useState(false);

	// In non-edit mode, just show the reference name
	if (!isEditable) {
		return <GenericPropertyInputRefContent value={integrationEventRef} />;
	}

	return (
		<GenericPropertyInput value={integrationEventRef} onValueChange={onIntegrationEventRefChange} onOpen={() => setOpen(true)}>
			<GenericPropertyInputRefContent value={integrationEventRef} />
			{open && (
				<IntegrationEventInputDialog
					open={open}
					setOpen={setOpen}
					integrationEventRef={integrationEventRef}
					onIntegrationEventRefChange={onIntegrationEventRefChange}
				/>
			)}
		</GenericPropertyInput>
	);
}
